module.exports = {
    barrel: {
        symbolsCount: 13,
        symbolNameFormat: "symbol_%d.png",
        blurNameFormat: "symbol_%d.png",
        reels: 5,
        rows: 3,
        position: {x: 68, y: 123},
        cellSize: {width: 160, height: 160},
        reelGap: 22
    },

    symbol_animation_filename_pattern: "symbol_%d",
    lines_filename_pattern: "line_%d",
    frames_filename_pattern: "frame_%d",
    
    left_billets_on_filename_pattern: "billet_on_%d.png",
    // left_billets_off_filename_pattern: "billet_off_%d.png",
    left_billets_coords: [
        {x:0, y:270 * 1.28}, // 1
        {x:0, y:141 * 1.28},  // 2
        {x:0, y:399 * 1.28}, // 3
        {x:0, y:98 * 1.28},  // 4
        {x:0, y:442 * 1.28}, // 5
        {x:0, y:313 * 1.28}, // 6
        {x:0, y:227 * 1.28}, // 7
        {x:0, y:184 * 1.28}, // 8
        {x:0, y:356 * 1.28}], // 9
    
    right_billets_on_filename_pattern: "billet_on_%d.png",
    // right_billets_off_filename_pattern: "billet_off_%d.png",
    right_billets_coords: [
        {x:764 * 1.28, y:270 * 1.28}, // 1
        {x:764 * 1.28, y:141 * 1.28},  // 2
        {x:764 * 1.28, y:399 * 1.28}, // 3
        {x:764 * 1.28, y:98 * 1.28},  // 4
        {x:764 * 1.28, y:442 * 1.28}, // 5
        {x:764 * 1.28, y:313 * 1.28}, // 6
        {x:764 * 1.28, y:227 * 1.28}, // 7
        {x:764 * 1.28, y:356 * 1.28}, // 9
        {x:764 * 1.28, y:184 * 1.28}], // 8
    
    animation_frames_count: [24,2,2,2,2,2,2,2,2,2,2,2,8],
    animation_speed: [0.12,0.05,0.05,0.05,0.05,0.05,0.05,0.05,0.05,0.05,0.05,0.05,0.12]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 12
// module chunks = 0